<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            <i class="las" :class="$router.currentRoute.meta.icon"></i>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">

                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <div class="row">                             
                                <div class="col-xl-8 col-lg-7">
                                    <div class="row">

                                        <div class="col-xs-12 col-xl-12"></div>

                                        <div class="col-xl-6 col-md-6 col-lg-12 col-xs-12">
                                            <div class="submit-field">
                                                <h5>
                                                    <ion-icon name="person-outline"></ion-icon>
                                                    Nome completo
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                                <input type="text" class="with-border" placeholder="Informe seu nome completo..." v-model="form.nome">
                                            </div>
                                        </div>                                                                                                 

                                        <div class="col-xl-6 col-md-6 col-lg-12 col-xs-12">
                                            <div class="submit-field">
                                                <h5>
                                                    <ion-icon name="mail-outline"></ion-icon>
                                                    E-mail
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                                <input type="email" class="with-border" placeholder="Informe seu e-mail aqui" v-model="form.email">
                                            </div>
                                        </div>

                                        <div class="col-xl-4 col-md-4 col-lg-7 col-xs-6">
                                            <div class="submit-field">
                                                <h5>
                                                    <ion-icon name="call-outline"></ion-icon>
                                                    Telefone
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                                <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border" placeholder="(__) _____-____" v-model="form.telefone" />
                                            </div>
                                        </div>    

                                        <!-- Button -->
                                        <div class="col-xl-12 margin-bottom-30 margin-top-30">
                                            <button type="submit" class="button color-green block-mobile">
                                                <i class="las la-save"></i>
                                                Salvar informações
                                            </button>
                                            <button v-on:click="$root.logout()" type="button" class="button color-red block-mobile">
                                                <i class="las la-power-off"></i>
                                                Deslogar do istema
                                            </button>                                            
                                            <router-link :to="{'name': 'AlterarSenha'}" class="button outline-gray block-mobile" style="overflow: inherit; border: none !important;">
                                                <i class="las la-lock"></i>
                                                Alterar senha
                                            </router-link>                                                        
                                        </div>
                                    </div>
                                </div>
                            </div>
                              
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'Conta',
    components: {
        'Top': Top,
        'Sidebar': Sidebar,
        'Toolbar': Toolbar,
        'AvatarCropper': AvatarCropper
    },    
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },         
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            return date + (time ? (" " + time) : "");
        }
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "imagem":           self.$root.user.imagem,
                "telefone":         self.$root.user.telefone,
                "doc":              self.$root.user.doc,
                "cnpj":             self.$root.user.cnpj,
                "razaoSocial":      self.$root.user.razaoSocial,
            }            
        }
    },
    methods: {
      
        getBase64Imagem: function(event) {
            console.log(">", event.target.files)
            var self            = this;

            if (event.target.files.length > 0) {
                loading.show();
                var files = [...event.target.files];
                self.$root.sequence(files, function(item) {
                    return new Promise(function(resolve, reject) {
                        if (self.form.imagens.length >= 5) {
                            reject("Erro! Você só pode enviar até 5 imagens.");
                        } else  {
                            reduceFileSize(item, 500*1024, 1000, Infinity, 0.9, blob => {
                                blobToBase64(blob, function(result) {
                                    // console.log("result", result);
                                    self.form.imagens.push(result);
                                    resolve(result);
                                });
                            }); 
                        }
                    }); 
                }).then(function(result) {

                    loading.hide();
                    console.log("getBase64Imagem() result", result);
                    self.$forceUpdate();

                }).catch(function(error) {
                    console.log("getBase64Imagem() error", error); 
                    loading.hide();
                    alert(error ? error : "Erro ao comprimir imagens");
                });
            }   
        },                      
        submit: function(e) {
            var self            = this;

            console.log("submit", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            self.form.painel    = true;
            
            axios.put("api/conta.php", self.form)
            .then(self.$root.getUser)
            .then(response => {
                self.loading.submit = false;
                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });                  
                loading.hide();
                alert("✅ Ok! Informações atualizadas com sucesso.");
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert(error.response.data.message || "Erro! Por favor, tente novamente.");
            });

        }
    },    
    created: function() {
        var self = this;
        console.log("Conta", self.$root.user)
        loading.show();
        Promise.all([
            self.$root.getUser()
        ]).then(function() {
        
            self.form = {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,                
                "nome":             self.$root.user.nome,
                "email":            self.$root.user.email,
                "imagem":           self.$root.user.imagem,
                "telefone":         self.$root.user.telefone,
                "doc":              self.$root.user.doc,
                "cnpj":             self.$root.user.cnpj,
                "razaoSocial":      self.$root.user.razaoSocial
            };
            self.$forceUpdate();

            loading.hide();

        }).catch(function(error) {
            loading.hide();
        }); 
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Conta.vue